module.exports = __webpack_public_path__ + "static/media/Hospitality.4a73fc68.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/Industries/Hospitality.svg
// module id = 318
// module chunks = 0